module.exports = __webpack_public_path__ + "img/yilianGl12.1a82a522.png";